/* eslint-disable */
import React from 'react';
import {
 ColDef,
 IDateFilterParams,
 ITextFilterParams,
} from '@ag-grid-community/core';
import CellRenderClipboard from '../../Shared/DataGrid/CellRenderClipboard';

const AppealsColumns = () => {
 const columns: ColDef[] = [];

 let column: ColDef = {
  field: 'recordNumber',
  headerName: '№',
  minWidth: 20,
  maxWidth: 80,
  filter: false,
  sortable: false,
  pinned: 'left',
  suppressFiltersToolPanel: true,
  suppressMenu: true,
  resizable: false,
  cellStyle: () => ({
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'center',
  }),
 };
 columns.push(column);

 column = {
  field: 'selection',
  headerName: '',
  maxWidth: 60,
  filter: false,
  sortable: false,
  pinned: 'left',
  resizable: false,
  suppressFiltersToolPanel: true,
  suppressMenu: true,
  checkboxSelection: false,
  cellRenderer: 'agGroupCellRenderer',
  lockVisible: true,
  cellStyle: () => ({
   display: 'flex',
   alignItems: 'space-around',
   justifyContent: 'space-around',
  }),
 };
 columns.push(column);

 column = {
  field: 'requestNumber',
  headerName: '№ обращения',
  maxWidth: 400,
  filter: 'agTextColumnFilter',
  filterParams: {
   buttons: ['apply', 'reset'],
   closeOnApply: true,
  } as ITextFilterParams,
  cellStyle: () => ({
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'left',
  }),
  lockVisible: false,
  cellRenderer: CellRenderClipboard,
 };

 columns.push(column);

 column = {
  field: 'question',
  headerName: 'Обращение',
  maxWidth: 600,
  filter: 'agTextColumnFilter',
  filterParams: {
   buttons: ['apply', 'reset'],
   closeOnApply: true,
  } as ITextFilterParams,
  cellStyle: () => ({
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'left',
  }),
  cellRenderer: CellRenderClipboard,
  lockVisible: false,
 };
 columns.push(column);

 column = {
  field: 'contractNumber',
  headerName: '№ договора',
  maxWidth: 200,
  cellStyle: () => ({
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'left',
  }),
  filter: 'agTextColumnFilter',
  filterParams: {
   buttons: ['apply', 'reset'],
   closeOnApply: true,
  } as ITextFilterParams,
  lockVisible: false,
  cellRenderer: CellRenderClipboard,
 };
 columns.push(column);

 column = {
  field: 'createDate',
  headerName: 'Дата создания',
  maxWidth: 300,
  cellStyle: () => ({
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'left',
  }),
  filter: 'agDateColumnFilter',
  filterParams: {
   comparator: (filterLocalDateAtMidnight, cellValue) => {
    if (cellValue == null) {
     return 0;
    }

    const dateParts = cellValue.split('.');
    const year = Number(dateParts[2]);
    const month = Number(dateParts[1]) - 1;
    const day = Number(dateParts[0]);
    const cellDate = new Date(year, month, day);

    if (cellDate < filterLocalDateAtMidnight) {
     return -1;
    } else if (cellDate > filterLocalDateAtMidnight) {
     return 1;
    }
    return 0;
   },

   buttons: ['apply', 'reset'],
   closeOnApply: true,
   inRangeFloatingFilterDateFormat: 'YYYY-MM-DD',
   inRangeInclusive: true,
  } as IDateFilterParams,
  cellRenderer: CellRenderClipboard,
  lockVisible: false,
 };
 columns.push(column);

 column = {
  field: 'requestDate',
  headerName: 'Дата и время регистрации обращения',
  maxWidth: 300,
  cellStyle: () => ({
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'left',
  }),
  filter: 'agDateColumnFilter',
  filterParams: {
   comparator: (filterLocalDateAtMidnight, cellValue) => {
    if (cellValue == null) {
     return 0;
    }

    const dateParts = cellValue.split('.');
    const year = Number(dateParts[2]);
    const month = Number(dateParts[1]) - 1;
    const day = Number(dateParts[0]);
    const cellDate = new Date(year, month, day);

    if (cellDate < filterLocalDateAtMidnight) {
     return -1;
    } else if (cellDate > filterLocalDateAtMidnight) {
     return 1;
    }
    return 0;
   },

   buttons: ['apply', 'reset'],
   closeOnApply: true,
   inRangeFloatingFilterDateFormat: 'YYYY-MM-DD',
   inRangeInclusive: true,
  } as IDateFilterParams,
  cellRenderer: CellRenderClipboard,
  lockVisible: false,
 };
 columns.push(column);

 column = {
  field: 'state',
  headerName: 'Статус',
  cellStyle: () => ({
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'left',
  }),
  filter: 'agTextColumnFilter',
  filterParams: {
   buttons: ['apply', 'reset'],
   closeOnApply: true,
  } as ITextFilterParams,
  cellRenderer: CellRenderClipboard,
  lockVisible: false,
 };
 columns.push(column);

 return { columns };
};

export { AppealsColumns };
